import extracteurDeParametres from "./extracteurDeParametresUrl";

export const CODE_PARTENAIRE_PARAM_NOM = 'code_partenaire'
export const CODE_PARRAIN_PARAM_NOM = 'code_parrain';

const parametresAExtraire = [
  CODE_PARTENAIRE_PARAM_NOM,
  CODE_PARRAIN_PARAM_NOM
]

export default function(query) {
  return extracteurDeParametres(query, parametresAExtraire);
}
